module.exports = "./img/b59dd83e6d6a55c11e1542aa8f17cd98.jpg";